import ErrorStatusPage from '@otovo/shared/components/ErrorStatusPage/ErrorStatusPage';
import { getStaticProps } from '../config/getProps';

export { getStaticProps };

export default ErrorStatusPage;
